// src/app/services/android-bridge.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AndroidBridgeService {

  /** Checks if Android bridge is available */
  private get android(): any | null {
    return (window as any).android || null;
  }

  /** Calls unLoad() safely if available */
  unload(): void {
    const android = this.android;
    if (android && typeof android.unLoad === 'function') {
      android.unLoad();
    } else {
      console.debug('Android unLoad not available');
    }
  }

  // Add more Android-specific functions here as needed
  doSomethingNative(methodName: string, ...args: any[]): void {
    const android = this.android;
    if (android && typeof android[methodName] === 'function') {
      android[methodName](...args);
    } else {
      console.debug(`Android method ${methodName} not available`);
    }
  }

  // Detect if running inside Android WebView
  isAndroidWebView(): boolean {
    return !!this.android;
  }
}
